import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { push } from "../../utils/navigation";
import ReactTable from "react-table";
import { Col, Row, Button } from "reactstrap";
import { BASE_URL, EMPTY_GUID } from "../../constants";
import { getOilTypes } from "../../actions/globalSettingAction";
import { mustBeArray } from "../../utils/lib";

const OilTypeMaster = (props) => {
  const [oilTypesList, setOilTypesList] = useState([]);

  function addNewOilType() {
    props.dispatch(push(`${BASE_URL}/manage/oil-types/${0}`));
  }

  function selectOilType(e, id = "") {
    e.preventDefault();
    props.dispatch(push(`${BASE_URL}/manage/oil-types/${id}`));
  }

  const columns = [
    {
      Header: "Code",
      accessor: "code",
      Cell: (row) => {
        return (
          <span
            className="text-primary hand text-center"
            onClick={(e) => selectOilType(e, row.original.id)}
          >
            {row.value}
          </span>
        );
      },
    },
    {
      Header: "Name",
      accessor: "name",
      Cell: (row) => {
        return (
          <span
            className="text-primary hand"
            onClick={(e) => selectOilType(e, row.original.id)}
          >
            {row.value}
          </span>
        );
      },
    },
  ];

  useEffect(() => {
    props.dispatch(getOilTypes()).then((x) => {
      setOilTypesList(mustBeArray(x.data));
    });
  }, []);

  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <h4>
            Tank Maintenance - Oil Types&nbsp;{" "}
            <Button color="success" onClick={addNewOilType}>
              <i className="fa fa-plus" /> Add Oil Type
            </Button>
          </h4>
        </Col>
        <Col>
          <ReactTable
            data={oilTypesList}
            columns={columns}
            sortable
            showPagination
            defaultPageSize={10}
            defaultSorted={[{ id: "code", desc: false }]}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OilTypeMaster);
